import { Action } from '@ngrx/store';
import { Address } from '../../../model/address.model';
import { OrderInformation } from '../../../model/order-information.model';
import { VoucherReference } from '@app/order-checkout/store';

export const ADD_ORDER_INFORMATION = '[ORDER INFORMATION] ADD';
export const UPSERT_ORDER_INFORMATION = '[ORDER INFORMATION] UPSERT';
export const RESET_ORDER_INFORMATION = '[ORDER INFORMATION] RESET';
export const UPDATE_ADDRESS = '[ORDER INFORMATION ADDRESS] UPDATE';
export const UPDATE_SAME_INVOICE_ADDRESS = '[SAME INVOICE ADDRESS] UPDATE';
export const VALIDATE = '[ORDER INFORMATION ADDRESS] VALIDATE';
export const VALIDATE_FAIL = '[ORDER INFORMATION ADDRESS] VALIDATE FAIL';
export const VALIDATE_SUCCESS = '[ORDER INFORMATION ADDRESS] VALIDATE SUCCESS';
export const VALIDATE_RESET = '[ORDER INFORMATION ADDRESS] VALIDATE RESET';
export const VALID_ORDER_INFORMATION_SET = '[ORDER INFORMATION] VALID INFORMATION SET';
export const SET_ERROR = '[ORDER INFORMATION] SET ERROR';
export const SET_INVALID_PAGE = '[ORDER INFORMATION] SET INVALID PAGE';
export const SET_VOUCHER_REFERENCE = '[ORDER INFORMATION] SET VOUCHER REFERENCE]';
export const INIT_VOUCHER_REFERENCE = '[ORDER INFORMATION] INIT VOUCHER REFERENCE]';

export enum ValidationStatus {
    IDLE = '[Validation Status] Idle',
    VALIDATING = '[Validation Status] Validating',
    VALID = '[Validation Status] Valid',
    INVALID = '[Validation Status] Invalid'
}

export class AddOrderInformation implements Action {
    readonly type = ADD_ORDER_INFORMATION;

    constructor(public orderInformation: OrderInformation) {
    }
}

export class UpsertOrderInformation implements Action {
    readonly type = UPSERT_ORDER_INFORMATION;

    constructor(public orderInformation: OrderInformation) {
    }
}

export class ResetOrderInformation implements Action {
    readonly type = RESET_ORDER_INFORMATION;

    constructor() {
    }
}

export class UpdateAddress implements Action {
    readonly type = UPDATE_ADDRESS;

    constructor(public addressType: string, public address: Address) {
    }
}

export class UpdateSameInvoiceAddressSwitch implements Action {
    readonly type = UPDATE_SAME_INVOICE_ADDRESS;

    constructor(public sameInvoiceAddressSwitch: boolean) {
    }
}

export class ValidOrderInformationSet implements Action {
    readonly type = VALID_ORDER_INFORMATION_SET;

    constructor(public payload: boolean) {
    }
}

export class Validate implements Action {
    readonly type = VALIDATE;
    constructor(public payload: any) {
    }
}

export class ValidateFail implements Action {
    readonly type = VALIDATE_FAIL;
    constructor(public payload: any) {
    }
}

export class ValidateSuccess implements Action {
    readonly type = VALIDATE_SUCCESS;
    constructor(public payload: any) {
    }
}

export class ValidateReset implements Action {
    readonly type = VALIDATE_RESET;
    constructor(public payload: any) {
    }
}

export class SetError implements Action {
    readonly type = SET_ERROR;
    constructor(public payload: string[]) {
    }
}

export class SetInvalidPage implements Action {
    readonly type = SET_INVALID_PAGE;
    constructor(public payload: string) {
    }
}

export class SetVoucherReference implements Action {
    readonly type = SET_VOUCHER_REFERENCE;
    public voucherReference: VoucherReference;

    constructor(public reference: string, public id: number | string, public hasSavings = false) {
        this.voucherReference = {
            id,
            reference,
            dateAdded: (new Date()).getTime(),
            isValid: hasSavings
        };
    }
}

export class InitVoucherReference implements Action {
    readonly type = INIT_VOUCHER_REFERENCE;
    constructor(public id: string) {}
}

export type OrderCheckoutActions = AddOrderInformation
| UpsertOrderInformation
| ResetOrderInformation
| UpdateAddress
| UpdateSameInvoiceAddressSwitch
| Validate
| ValidateFail
| ValidateReset
| ValidateSuccess
| ValidOrderInformationSet
| SetError
| SetInvalidPage
| SetVoucherReference;
